import * as t from "react";
import a from "../lib/IconBase.es.js";
import i from "../defs/CaretRight.es.js";
const e = t.forwardRef((o, r) => /* @__PURE__ */ t.createElement(a, { ref: r, ...o, weights: i }));
e.displayName = "CaretRightIcon";
const s = e;
export {
  s as CaretRight,
  e as CaretRightIcon
};
